"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.type = exports.typeIA = void 0;
exports.typeIA = '(90)';
exports.type = {
    box: '01',
    product: '02',
    productV2: '03',
    customer: '04'
};
//# sourceMappingURL=types.js.map